import { render, staticRenderFns } from "./Add.vue?vue&type=template&id=6bbb483d&scoped=true&"
import script from "./Add.vue?vue&type=script&lang=js&"
export * from "./Add.vue?vue&type=script&lang=js&"
import style0 from "./Add.vue?vue&type=style&index=0&id=6bbb483d&prod&lang=scss&"
import style1 from "./Add.vue?vue&type=style&index=1&id=6bbb483d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bbb483d",
  null
  
)

export default component.exports